module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-76x76-c59b1f4b8881c7bc383b8e783a258858.png";